import { BookLockIcon } from './BookLockIcon';

/**
 * author: Michael Richins
 * id 121AF367-3AE5-48D1-9868-8DC60342D4A0
 * name book-lock
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-lock.svg
 * tags
 * - Lock 
 */
export const BookSecureIcon = BookLockIcon;
export default BookSecureIcon